{
  "active": "Active",
  "associateToType": "Associate with cost type",
  "closedEvent": "Closed event",
  "completed": "Completed",
  "contactRegistererd": "contact has registrered self-effort to this event.",
  "contactsRegistered": "contacts have registered self-effort to this event.",
  "copyRegistrationLink": "Copy registration link",
  "couldNotCreateEvent": "Could not create event. Please try again.",
  "couldNotDeleteEvent": "Could not delete event. Please try again.",
  "couldNotEditEvent": "Could not edit event. Please try again.",
  "createEvent": "Create event",
  "deleteEventWarning": "Are you sure you want to delete this event? All self-effort registered to this event will be deleted.",
  "editEvent": "Edit event",
  "errorCode.DatesOutsideOfParent": "The date range of the event is outside of parent project/activity",
  "errorCode.ExpenseTypesNotPresentInProject": "An expense type not part of the project/activity cannot be used in a child event",
  "eventDescription": "Event description",
  "eventName": "Event name",
  "eventOverview": "Event overview",
  "eventParticipants": "Event participants",
  "expectedDuration": "Expected duration",
  "getRegistrartionInfo": "Get registration information",
  "hours": "hours",
  "linkCopied": "Link copied!",
  "location": "Location",
  "minutes": "minutes",
  "newEvent": "New event",
  "noParticipantsRegistered": "No participants registered",
  "numberOfEvents": "Number of events",
  "numberOfEventsDistributedOnActivities": "divided into {{activityCount}} activities",
  "printQrCode": "Print QR-code",
  "qrCodeDescription": "Print the QR-code and have it available for fast registration of self-effort on you event.",
  "qrCodeFor": "QR-code for",
  "qrCodeForRegistering": "QR-code for registering at",
  "qrCodeSidebarDescription": "Participants can register inkind themselves via this QR-code on the event or from a link you can send via email.",
  "registrationLink": "Registration link",
  "scanQrCode": "Scan the QR-code to open the registration link",
  "selectEvent": "Select event",
  "selfRegistration": "Self registration",
  "showAllContacts": "Show all contacts with with self-effort registered to this event:",
  "upcoming": "Upcoming",
  "uploadLogo": "Upload logo (optional)",
  "gotoAllEvents": "Go to all events"
}
